import { httpGet } from '../../utils/httpClients';
import { AllyConfig } from '../../components/addi-product-widget/addi-product-widget.d';
import {
  BR_CHANNELS_PUBLIC_API,
  CO_CHANNELS_PUBLIC_API,
} from '../../constants';

export const getAllyConfigCo = async (
  requestedAmount: number,
  allySlug?: string
): Promise<AllyConfig | undefined> => {
  if (!allySlug) throw new Error('allySlug not found');
  try {
    const PATH = `/allies/${allySlug}/config${
      requestedAmount ? `?requestedAmount=${requestedAmount}` : ''
    }`;
    const response = await httpGet(CO_CHANNELS_PUBLIC_API, PATH, {
      timeout: 3000,
    });
    return response;
  } catch (error) {
    return;
  }
};

export const getAllyConfigBr = async (
  requestedAmount: number,
  allySlug?: string
): Promise<AllyConfig | undefined> => {
  try {
    const PATH = `/allies/${allySlug}/config${
      requestedAmount ? `?requestedAmount=${requestedAmount}` : ''
    }`;
    const response = await httpGet(BR_CHANNELS_PUBLIC_API, PATH, {
      timeout: 3000,
    });
    return response;
  } catch (error) {
    return;
  }
};
